import * as React from "react";
const SvgArrowDown24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 12,
        fill: "black",
        viewBox: "0 0 20 12"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M19.707 1.707 18.293.293 10 8.586 1.707.293.293 1.707 10 11.414l9.707-9.707Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowDown24Px;
